import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LocationSelector from "./components/LocationSelector";
import ClinicHome from "./components/ClinicHome";
import TeamPage from "./components/TeamPage";
import GalleryPage from "./components/GalleryPage";
import SessionsPage from "./components/SessionsPage";
import PrivacyPage from "./components/PrivacyPage";
import AdminLogin from "./components/AdminLogin";
import AdminDashboard from "./components/AdminDashboard";
import AdminContentEdit from "./components/AdminContentEdit";
import AdminTeamEdit from "./components/AdminTeamEdit";
import AdminGalleryEdit from "./components/AdminGalleryEdit";
import AdminLocationEdit from "./components/AdminLocationEdit";
import AdminSessionsEdit from "./components/AdminSessionsEdit";
import ChangePassword from "./components/ChangePassword";
import ProtectedRoute from "./components/ProtectedRoute";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LocationSelector />} />
          <Route path="/:locationSlug" element={<ClinicHome />} />
          <Route path="/:locationSlug/team" element={<TeamPage />} />
          <Route path="/:locationSlug/gallery" element={<GalleryPage />} />
          <Route path="/:locationSlug/sessions" element={<SessionsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookies" element={<PrivacyPage />} />
          <Route path="/legal" element={<PrivacyPage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/:locationSlug/content"
            element={
              <ProtectedRoute>
                <AdminContentEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/:locationSlug/team"
            element={
              <ProtectedRoute>
                <AdminTeamEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/:locationSlug/gallery"
            element={
              <ProtectedRoute>
                <AdminGalleryEdit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/:locationSlug/location"
            element={
              <ProtectedRoute>
                <AdminLocationEdit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/:locationSlug/sessions"
            element={
              <ProtectedRoute>
                <AdminSessionsEdit />
              </ProtectedRoute>
            }
          />

          <Route
            path="/admin/change-password"
            element={
              <ProtectedRoute>
                <ChangePassword />
              </ProtectedRoute>
            }
          />

          {/* Redirect /admin to dashboard if logged in, otherwise to login */}
          <Route path="/admin" element={<AdminRedirect />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;

function AdminRedirect() {
  // perform a quick check to /admin/me and redirect accordingly
  const [ready, setReady] = React.useState(false);
  const [isAdmin, setIsAdmin] = React.useState(false);
  React.useEffect(() => {
    import("./api/api").then(({ getCurrentAdmin }) => {
      getCurrentAdmin()
        .then((res) => {
          if (res && res.user && res.user.role === "admin") setIsAdmin(true);
        })
        .catch(() => {})
        .finally(() => setReady(true));
    });
  }, []);
  if (!ready) return null;
  return isAdmin ? (
    <Navigate to="/admin/dashboard" replace />
  ) : (
    <Navigate to="/admin/login" replace />
  );
}
